// Domains section (former xpnsr-seo-addon), mounted at /dm/* inside the main Layout.
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ConfirmDialogProvider } from "./components/ConfirmDialog";
import { Toaster } from "./components/ui/sonner";
import "./dm.css";
import { useLang } from "../i18n";
import { setDomainsLang } from "./i18n";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const AddDomain = lazy(() => import("./pages/AddDomain"));
const EditDomain = lazy(() => import("./pages/EditDomain"));
const DomainDetails = lazy(() => import("./pages/DomainDetails"));
const Accounts = lazy(() => import("./pages/Accounts"));
const DNSManager = lazy(() => import("./pages/DNSManager"));
const PagesManager = lazy(() => import("./pages/PagesManager"));
const PBN = lazy(() => import("./pages/PBN"));
const FTPDeploy = lazy(() => import("./pages/FTPDeploy"));
const Wizard = lazy(() => import("./pages/Wizard"));
const Spaceship = lazy(() => import("./pages/Spaceship"));
const Workers = lazy(() => import("./pages/Workers"));
const Settings = lazy(() => import("./pages/Settings"));

function PageFallback() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="loading-spinner" style={{ width: "2.5rem", height: "2.5rem" }} />
    </div>
  );
}

export default function DomainsRoutes() {
  // Follow the app-wide EN/RU switch; re-renders the section on change.
  const { lang } = useLang();
  setDomainsLang(lang);
  return (
    <ConfirmDialogProvider>
      {/* Same page padding as the rest of the app; dm-page scopes design overrides */}
      <div className="xp-page-pad dm-page">
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="add-domain" element={<AddDomain />} />
          <Route path="edit-domain/:id" element={<EditDomain />} />
          <Route path="domain/:id" element={<DomainDetails />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="dns" element={<DNSManager />} />
          <Route path="pages" element={<PagesManager />} />
          <Route path="pbn" element={<PBN />} />
          <Route path="ftp" element={<FTPDeploy />} />
          <Route path="wizard" element={<Wizard />} />
          <Route path="spaceship" element={<Spaceship />} />
          <Route path="workers" element={<Workers />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/dm" replace />} />
        </Routes>
      </Suspense>
      </div>
      <Toaster richColors position="top-right" />
    </ConfirmDialogProvider>
  );
}
